import React, { useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

function ManageYourBookingTabContent({
  setCurrentTab,
  formState,
  updateFormState,
  setType,
}) {
  const formik = useFormik({
    initialValues: {
      bookingOption: formState.bookingOption || null,
    },
    enableReinitialize: true, 
    validationSchema: Yup.object({
      bookingOption: Yup.string().required("Please select an option"),
    }),
    onSubmit: (values) => {
      updateFormState({ bookingOption: values.bookingOption });
      setType(2); // Proceed to next step
    },
  });
  return (
    <section className="ob-supplier-content-body">
      <div className="mt-4 ob-supplier-content-form">
        <h1 className="ob-supplier-content-heading mt-3 mb-1">
          Tell us about how you manage your bookings
        </h1>
        <p className="ob-pi-form-description mt-0 mb-2">
          You may tell us about if you are already using a system to display
          your products online
        </p>
        <Form className="mt-4" onSubmit={formik.handleSubmit}>
          <div>
            <div data-tooltip-id={`ob-manage-booking-question-tooltip`}>
              <p className="ob-pi-label m-0">
                Do you use an online reservation system?<span className="text-danger ps-1">*</span>
              </p>
              <p className="ob-pi-form-description mt-0 mb-2">
                In case you are already in use of any online or offline system
                to manage
              </p>
              <div className={`d-flex align-items-center`}>
              <label htmlFor="option1" className={`d-flex align-items-center w-100`}>
                <Form.Check
                  type="radio"
                  id="option1"
                  className={"radio-button m-0"}
                  name="bookingOption"
                  value="yes"
                  checked={formik.values.bookingOption === "yes"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={
                    !!formik.errors.bookingOption && formik.touched.bookingOption
                  }
                />
                <div
                  className={`d-flex align-items-center ob-supplier-radio-item-wrapper mt-1`}
                >
                  <p className={"m-0 ob-supplier-radio-item-text2"}>Yes</p>
                </div>
              </label>
            </div>
            
              <div className={`d-flex align-items-center`}>
                  <label htmlFor="option2" className={`d-flex align-items-center w-100`}>
                    <Form.Check
                      type="radio"
                      id="option2"
                      className={"radio-button m-0"}
                      name="bookingOption"
                      value="no"
                      checked={formik.values.bookingOption === "no"}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.bookingOption && formik.touched.bookingOption
                      }
                    />
                    <div
                      className={`d-flex align-items-center ob-supplier-radio-item-wrapper mt-1`}
                    >
                      <p className={"m-0 ob-supplier-radio-item-text2"}>No</p>
                    </div>
                  </label>
                </div>

              {formik.errors.bookingOption && formik.touched.bookingOption && (
                <div className="invalid-feedback d-flex">
                  {formik.errors.bookingOption}
                </div>
              )}
              {/* <ReactTooltip
                id={`ob-manage-booking-question-tooltip`}
                className="tooltip"
                place="right"
                content={() => (
                  <div>
                    This might help you in connecting your inventory with our
                    system 
                  </div>
                )}
              />*/}
            </div>
            <div className="d-flex justify-content-between mt-5">
              <button className="back-btn" onClick={() => setCurrentTab(3)}>
                Back
              </button>
              <button type="submit" className="submit-btn">
                Save & Continue
              </button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
}

export default ManageYourBookingTabContent;
